module.exports = __webpack_public_path__ + "img/Weapon_175.0c0686fe.png";